import { FC, useMemo } from "react";

import {
  FilterByIdListConfigurationView,
  FilterByIdListItem,
} from "@/domain/view/components/datatable/datatable-filters/filter-by-id-list-configuration-view.tsx";

import { useSmartFocusAreaList } from "../../hooks/api/use-smart-focus-area-list";
import { FocusAreaViewOptional } from "../focus-area-view-optional";

export interface DatatableFocusAreaConfigurationViewProps {
  workspaceId: string;
  columnId: string;
  onFinished: () => void;
}

export const DatatableFocusAreaConfigurationView: FC<DatatableFocusAreaConfigurationViewProps> = ({
  onFinished,
  workspaceId,
  columnId,
}) => {
  const { focusAreaList, findFocusAreaById } = useSmartFocusAreaList({
    workspaceId: workspaceId,
  });

  const itemList = useMemo(() => {
    return focusAreaList.map((focusArea) => ({
      id: focusArea.id,
      name: focusArea.name,
    }));
  }, [focusAreaList]);

  const renderItem = (item: FilterByIdListItem | null, view: "icon" | "text" | "icon-text") => {
    const showText = view === "text" || view === "icon-text";

    return <FocusAreaViewOptional key={item?.id} focusArea={findFocusAreaById(item?.id ?? "")} logoOnly={!showText} />;
  };

  return (
    <FilterByIdListConfigurationView
      columnId={columnId}
      itemList={itemList}
      renderItem={renderItem}
      onFinished={onFinished}
    />
  );
};
